import React, { useEffect } from 'react';
import { AppUser } from '../types';
import { REFERRAL_GA } from '../services/accessControl';
import { captureReferralFromUrl, getPendingReferral } from '../utils/referralCapture';
import { claimPendingReferral } from '../services/referralService';

/**
 * Siste-mil-wiring for verving (#3 Reciprocity). Usynlig — fanger ?ref-koden ved
 * app-start (før innlogging) og melder den inn når brukeren er innlogget, så vervet
 * får premium-måneden med en gang. Gated på REFERRAL_GA. Se docs/plan-ux-principles-retention.md.
 */
const ReferralHandler: React.FC<{ user: AppUser | null }> = ({ user }) => {
  // Fang ?ref så tidlig som mulig (uskadelig selv om flagget er av).
  useEffect(() => {
    captureReferralFromUrl(window.location.search);
  }, []);

  // Meld inn ventende kode én gang når brukeren er innlogget.
  useEffect(() => {
    if (!REFERRAL_GA || !user?.uid) return;
    if (!getPendingReferral()) return;
    claimPendingReferral();
  }, [user?.uid]);

  return null;
};

export default ReferralHandler;
